// @flow
import Stopwatch from 'app/packages/trace-logger/Stopwatch';
import traceLogger from 'app/packages/trace-logger/singleton';

export default function addPageBinaryAnnotations(currTimer: ?Stopwatch) {
  if (currTimer) {
    const timer = currTimer;
    if (traceLogger.serverTraceData.binary_annotations) {
      traceLogger.serverTraceData.binary_annotations.forEach((entry) => {
        timer.addBinaryAnnotation(entry);
      });
    }
  }
}
